/**
 * 이미지를 Gemini 에 보낼 모양(base64)으로 바꾼다.
 *
 * 공유받은 문장 카드는 휴대폰 화면 크기(1080×1920 안팎)라 그대로 보내면 모바일 데이터로
 * 수 MB 가 오간다. 글자를 읽기에는 긴 변 1600px 이면 충분해서 그보다 크면 줄인다.
 * 줄이다 실패하면(오래된 브라우저 등) 원본을 그대로 보낸다.
 */
const MAX_SIDE = 1600;

const toBase64 = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result).split(',')[1] || '');
  reader.onerror = () => reject(reader.error);
  reader.readAsDataURL(blob);
});

const shrink = async (blob) => {
  const bitmap = await createImageBitmap(blob);
  try {
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    if (scale === 1) return blob;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const smaller = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.9));
    return smaller || blob;
  } finally {
    bitmap.close?.();
  }
};

/** @returns {Promise<{ mimeType: string, data: string }>} */
export const toGeminiImage = async (blob) => {
  let source = blob;
  try { source = await shrink(blob); }
  catch { /* 줄이지 못하면 원본 */ }
  return { mimeType: source.type || 'image/png', data: await toBase64(source) };
};
